import React from 'react'
import { ReviewItems } from '../ReviewItems'
import {
  formatAddress,
  formatPersonName,
  formatReviewString
} from '../../utilities'
import {
  ageLabel,
  dobLabel,
  homeAddressLabel,
  nameLabel,
  sexLabel
} from '../../strings/labels'

export const ReviewIHSVictim = ({
  first_name,
  middle_name,
  last_name,
  suffix,
  age,
  dob,
  sex,
  address,
  address2,
  city,
  state,
  zip,
  country,
  editFieldName,
  onClick
}) => {
  let personal_details = [
    {
      heading: nameLabel,
      value: formatReviewString(
        formatPersonName(first_name, middle_name, last_name, suffix)
      )
    },
    {
      heading: dobLabel,
      value: formatReviewString(dob)
    },
    {
      heading: ageLabel,
      value: age ? formatReviewString(age.toString()) : formatReviewString()
    },
    {
      heading: sexLabel,
      value: formatReviewString(sex)
    },
    {
      heading: homeAddressLabel,
      value: formatReviewString(
        formatAddress({
          line1Value: address,
          line2Value: address2,
          cityValue: city,
          stateValue: state,
          zipValue: zip,
          countryValue: country
        })
      )
    }
  ]

  const addCommonProps = items =>
    items.map(item => {
      return {
        ...item,
        field_name: editFieldName,
        onClick
      }
    })

  personal_details = addCommonProps(personal_details)

  return <ReviewItems items={personal_details} />
}
